"use client";

import { Button, Flex, Icon, useActions, type UIAction } from "@huub-web/ui";
import type { FC, Ref } from "react";
import { useTranslation } from "react-i18next";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";
import { useTemplates } from "../../hooks";

export type ModelTemplateProps = {
  /**
   * The title to display at the top of the model
   */
  title?: string;
  /**
   * The description to display below the title
   */
  description?: string;
  /**
   * The templates to render within the model
   */
  templates?: TemplateCollection;
  /**
   * The action to perform when the back button is clicked
   */
  backAction?: UIAction;
  /**
   * Ref forwarded to the root element
   */
  ref?: Ref<HTMLDivElement>;
};

/**
 * A template wrapper for rendering a model with optional back navigation and nested templates.
 */
export const ModelTemplate: FC<ModelTemplateProps> = ({
  templates,
  backAction,
  ref,
}) => {
  const { t } = useTranslation();
  const { handleAction } = useActions();
  const { lockUI } = useTemplates();

  const handleBackClick = () => {
    if (backAction) {
      handleAction(backAction);
    }
  };

  return (
    <Flex direction="column" gap="s" ref={ref}>
      {backAction && (
        <Button
          onClick={handleBackClick}
          leading={<Icon icon="chevronLeft" />}
          variant="tertiary"
          alignSelf="flex-start"
          disabled={lockUI}
        >
          {t("back")}
        </Button>
      )}
      {/* 
        {title && (
          <>
            <Spacing />
            <Text variant="displayXS" bold>
              {title}
            </Text>
            <Spacing />
          </>
        )} */}

      {templates && <TemplatesParser templates={templates} level={1} />}
    </Flex>
  );
};
